export default "__VITE_ASSET__CPNxJFRK__"